











import { Mixins } from 'vue-mixin-decorator'
import { Component, Prop } from 'vue-property-decorator'

import { AddToCartButtonDependency } from '@spa/components/pages/mypage/order/models/add-to-cart-button-dependency'
import { Order } from '@spa/store/modules/orderHistory/types'
import { PluginMixin } from '../../../../mixins/plugin'
import OrderListItem from './OrderListItem.vue'

@Component({
  components: {
    OrderListItem,
  },
})
export default class OrderList extends Mixins<PluginMixin>(PluginMixin) {
  @Prop()
  orders: Order[]

  @Prop({ required: true })
  readonly addToCartButtonDependency: AddToCartButtonDependency
}
